import { useMainStore } from "@/store/main";
import { HorizontalMenu } from "@/components/Common/HorizontalMenu/HorizontalMenu";
import { useExplorerOnlyMode } from "@/hooks/useExplorerOnlyMode";

export const MainMenu = () => {
  const tool = useMainStore((state) => state.tool);
  const explorerOnlyMode = useExplorerOnlyMode();

  if (!explorerOnlyMode) return null;

  return <HorizontalMenu items={tool?.menuItems} toolName={tool?.value} />;
};
